import { render, staticRenderFns } from "./ConfirmationCopy.vue?vue&type=template&id=1e5facbd&"
import script from "./ConfirmationCopy.vue?vue&type=script&lang=js&"
export * from "./ConfirmationCopy.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationCopy.vue?vue&type=style&index=0&id=1e5facbd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports